import { mergeTranslations } from "ra-core";
import polyglotI18nProvider from "ra-i18n-polyglot";
import englishMessages from "ra-language-english";
import frenchMessages from "ra-language-french";
import spanishMessages from "ra-language-spanish";
import { raSupabaseEnglishMessages } from "ra-supabase-language-english";
import { raSupabaseFrenchMessages } from "ra-supabase-language-french";
import { englishCrmMessages } from "./englishCrmMessages";
import { frenchCrmMessages } from "./frenchCrmMessages";
import { spanishCrmMessages } from "./spanishCrmMessages";

const raSupabaseEnglishMessagesOverride = {
  "ra-supabase": {
    auth: {
      password_reset: "Check your emails for a Reset Password message.",
    },
  },
};

const raSupabaseFrenchMessagesOverride = {
  "ra-supabase": {
    auth: {
      password_reset:
        "Consultez vos emails pour trouver le message de reinitialisation du mot de passe.",
    },
  },
};

// ra-supabase no tiene paquete oficial en español — sobreescribimos las pocas
// strings de auth que ra-supabase introduce, en lugar de heredar de inglés.
const raSupabaseSpanishMessagesOverride = {
  "ra-supabase": {
    auth: {
      missing_email: "Por favor, ingresa tu correo electrónico",
      missing_password: "Por favor, ingresa tu contraseña",
      password_reset:
        "Revisa tu correo para encontrar el mensaje de recuperación de contraseña.",
    },
  },
};

const englishCatalog = mergeTranslations(
  englishMessages,
  raSupabaseEnglishMessages,
  raSupabaseEnglishMessagesOverride,
  englishCrmMessages,
);

const frenchCatalog = mergeTranslations(
  englishCatalog,
  frenchMessages,
  raSupabaseFrenchMessages,
  raSupabaseFrenchMessagesOverride,
  frenchCrmMessages,
);

// El catálogo en español hereda del inglés (fallback para cualquier string
// que aún no esté traducida) y aplica encima ra-language-spanish + nuestras
// traducciones específicas de Musco CRM.
const spanishCatalog = mergeTranslations(
  englishCatalog,
  spanishMessages,
  raSupabaseSpanishMessagesOverride,
  spanishCrmMessages,
);

export const getInitialLocale = (): "en" | "fr" | "es" => {
  if (typeof navigator === "undefined") {
    return "es";
  }

  const browserLocale = navigator.languages?.[0] ?? navigator.language;
  const lowercased = browserLocale?.toLowerCase() ?? "";

  if (lowercased.startsWith("es")) {
    return "es";
  }
  if (lowercased.startsWith("fr")) {
    return "fr";
  }

  // Default español para Musco — equipo Mx
  return "es";
};

export const i18nProvider = polyglotI18nProvider(
  (locale) => {
    if (locale === "fr") {
      return frenchCatalog;
    }
    if (locale === "es") {
      return spanishCatalog;
    }
    return englishCatalog;
  },
  getInitialLocale(),
  [
    { locale: "es", name: "Español" },
    { locale: "en", name: "English" },
    { locale: "fr", name: "Français" },
  ],
  { allowMissing: true },
);

export const testI18nProvider = polyglotI18nProvider(
  () => englishCatalog,
  "en",
  [{ locale: "en", name: "English" }],
  { allowMissing: true },
);
